module.exports = __webpack_public_path__ + "img/Finger.88202b6a.svg";